<template>
    <div>
        <div class="row">
            <div v-if="projects.length > 0" class="bg-white shadow-md rounded mb-6 mt-4 w-full">
                <table class="text-left w-full border-collapse">
                    <thead>
                        <tr>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('name')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'name' ? 'text-teal' : 'text-grey-darkest'">
                                    Project Name
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'name' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'name' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-boldco uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('sequential_team_id')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'sequential_team_id' ? 'text-teal' : 'text-grey-darkest'">
                                        ID
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'sequential_team_id' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'sequential_team_id' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-boldco uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('contact_name')"
                                        class="font-bold uppercase text-xs"
                                        :class="this.currentFilter.property === 'contact_name' ? 'text-teal' : 'text-grey-darkest'">
                                    Contact
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                       v-if="this.currentFilter.property === 'contact_name' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                       v-if="this.currentFilter.property === 'contact_name' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('bid_date')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'bid_date' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(fieldLabels , 'bid-date')}}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'bid_date' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'bid_date' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('sales')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'sales' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(fieldLabels , 'status')}}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'sales' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'sales' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light">
                                <button @click="parseFilter('base_bid')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'base_bid' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(recordDetailFieldLabels , 'base-bid')}}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'base_bid' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'base_bid' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden md:table-cell">
                                <button @click="parseFilter('contract_amount')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'contract_amount' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(recordDetailFieldLabels , 'contract-amount')}}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'contract_amount' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'contract_amount' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                <button @click="parseFilter('estimator')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'estimator' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(fieldLabels , 'estimator')}}

                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'estimator' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'estimator' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                <button @click="parseFilter('account_manager')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'account_manager' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(fieldLabels , 'account-mgr')}}


                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'account_manager' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'account_manager' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
                            <th class="py-3 px-6 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light hidden lg:table-cell">
                                <button @click="parseFilter('take_off_person')"
                                    class="font-bold uppercase text-xs"
                                    :class="this.currentFilter.property === 'take_off_person' ? 'text-teal' : 'text-grey-darkest'">
                                    {{getFieldLabel(fieldLabels , 'take-off-person')}}
                                    <i class="fa fa-xs fa-chevron-down ml-2"
                                        v-if="this.currentFilter.property === 'take_off_person' && this.currentFilter.direction === 'desc'"></i>
                                    <i class="fa fa-xs fa-chevron-up ml-2"
                                        v-if="this.currentFilter.property === 'take_off_person' && this.currentFilter.direction === 'asc'"></i>
                                </button>
                            </th>
<!--                            <th class="py-3 pr-2 bg-grey-lightest font-bold uppercase text-xs text-grey-darkest border-b border-grey-light font-bold uppercase text-xs lg:table-cell">-->
<!--                                Change Order-->
<!--                            </th>-->
                        </tr>
                    </thead>
                    <tbody v-for="project in finalArray" >
                        <tr @click.prevent="editProject(project)" class="hover:bg-grey-lighter cursor-pointer"
                            :key="project.id" >
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div class="text-sm">{{ project.name }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.custom_project_id ? project.custom_project_id : project.sequential_team_id }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.contact_name }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.bid_date }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div>{{ project.sales }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs">
                                <div>{{ project.base_bid }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden md:table-cell">
                                <div>{{ project.contract_amount }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden lg:table-cell">
                                <div>{{ project.estimator }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden lg:table-cell">
                                <div>{{ project.account_manager }}</div>
                            </td>
                            <td class="pl-4 py-3 border-b border-grey-light text-xs hidden lg:table-cell">
                                <div>{{ project.take_off_person }}</div>
                            </td>
<!--                            <td class="py-3 pr-2 border-b border-grey-light text-xs  hidden lg:table-cell">-->
<!--                                <ul v-for="(change,index) in project.change_order" v-if="project.change_order.length > 0 && project.project_change_orders === 1 && project.has_pipeline_graph === 1" style="list-style-type: square !important;">-->
<!--                                    <li>{{ project.name }} - {{ change.change_order }} {{ index+1 }}</li>-->
<!--                                </ul>-->
<!--                            </td>-->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>


<script>
import { parse } from 'path';
export default {
    props: ['projects', 'fieldLabels', 'recordDetailFieldLabels'],
    data() {
        return {
            list: [],
            filtered: [],
            finalArray: [],
            currentFilter: {
                property: null,
                direction: null
            },
            sortFilter:{
                name: 'sortName',
                sequential_team_id: 'sortSequentialTeamId',
                bid_date: 'sortBidDate',
                contact_name: 'sortContact',
                sales: 'sortSales',
                base_bid: 'sortBaseBid',
                contract_amount: 'sortContractAmount',
                estimator: 'sortEstimator',
                account_manager: 'sortAccountManager',
                take_off_person: 'sortTakeOffPerson'
            },
        }
    },

    created() {
        let finalArray = [];
        this.list = [ ...this.projects ];
        this.filtered = [ ...this.projects ];
        this.finalArray = this.filtered.map((value, index) => {
            let changeOrderVal = [];
            if(value.change_order.length > 0) {
                value.change_order.map((val, index) => {
                    if (val.sales_status != null){
                        changeOrderVal.push({
                            'change_order' : 'Change Order ',
                            'base_bid_amount' : val.base_bid_amount,
                        });
                    }
                });
            }
            return({
                ...value,
                'change_order': changeOrderVal
            })
        });
    },

    methods: {
        editProject(project) {
            window.location = route('project.edit', {project: project.id});
        },

        parseFilter(property) {
            if (property === this.currentFilter.property) {
                this.currentFilter.direction = this.currentFilter.direction === 'desc' ? 'asc' : 'desc';
            } else if (property !== this.currentFilter.property || !this.currentFilter.direction) {
                this.currentFilter.direction = 'asc';
            }

            this.currentFilter.property = property;

            let finalArraySorted = this.filtered.sort(this.sortMaster);
            this.finalArray = finalArraySorted;        },
        sortMaster(a,b){
            let sortFunc = this[this.sortFilter[this.currentFilter.property]];
            return sortFunc(a,b) * (this.currentFilter.direction === 'desc' ? 1 : -1);
        },
        sortName(a,b){
            if(!a.name) return -1;
            if(!b.name) return 1;
            return a.name.localeCompare(b.name);
        },
        sortSequentialTeamId(a,b){
            if(!a.sequential_team_id) return -1;
            if(!b.sequential_team_id) return 1;
            return a.sequential_team_id > b.sequential_team_id ? 1 : -1;
        },
        sortBidDate(a,b){
            if(!a.bid_date) return -1;
            if(!b.bid_date) return 1;
            a = a.bid_date.split('/');
            b = b.bid_date.split('/');
            return new Date(a[2],a[0],a[1]) > new Date( b[2], b[0], b[1]) ? 1 : -1;
        },
        sortContact(a,b){
            if(!a.contact_name) return -1;
            if(!b.contact_name) return 1;
            return a.contact_name.localeCompare(b.contact_name);
        },
        sortSales(a,b){
            if(!a.sales) return -1;
            if(!b.sales) return 1;
            return a.sales.localeCompare(b.sales);
        },
        sortBaseBid(a,b){
            if(!a.base_bid) return -1;
            if(!b.base_bid) return 1;
            a = a.base_bid.replace(/(\$|\,)/g, '');
            b = b.base_bid.replace(/(\$|\,)/g, '');
            return parseFloat(a) > parseFloat(b) ? 1 : -1;
        },
        sortContractAmount(a,b){
            if(!a.contract_amount) return -1;
            if(!b.contract_amount) return 1;
            a = a.contract_amount.replace(/(\$|\,)/g, '');
            b = b.contract_amount.replace(/(\$|\,)/g, '');
            return parseFloat(a) > parseFloat(b) ? 1 : -1;
        },
        sortEstimator(a,b){
            if(!a.estimator) return -1;
            if(!b.estimator) return 1;
            return a.estimator.localeCompare(b.estimator);
        },
        sortAccountManager(a,b){
            if(!a.account_manager) return -1;
            if(!b.account_manager) return 1;
            return a.account_manager.localeCompare(b.account_manager);
        },
        sortTakeOffPerson(a,b){
            if(!a.take_off_person) return -1;
            if(!b.take_off_person) return 1;
            return a.take_off_person.localeCompare(b.take_off_person);
        },
    },
}
</script>

